import { fuelSavingReducer } from '@makemydeal/dr-activities-fuel-saving';
import { fuelSavingMiddleware } from './middleware';

export const fuelSavingConfiguration = {
    middleware: fuelSavingMiddleware,
    reducer: fuelSavingReducer
};
